import React from "react"
import { View } from "react-native"
import Animated, { Extrapolate, interpolate, useAnimatedStyle } from "react-native-reanimated"

const PaginationItem: React.FC<{
    index: number; length: number;
    width: number; height: number;
    viewStyle; highlightedViewStyle
    animValue: Animated.SharedValue<number>;
}> = (props) => {
    const { animValue, index, length, width, height, viewStyle, highlightedViewStyle } = props;

    const animStyle = useAnimatedStyle(() => {
        let inputRange = [index - 1, index, index + 1];
        let outputRange = [-width, 0, width];

        if (index === 0 && animValue?.value > length - 1) {
            inputRange = [length - 1, length, length + 1];
            outputRange = [-width, 0, width];
        }

        return {
            transform: [
                {
                    translateX: interpolate(
                        animValue?.value,
                        inputRange,
                        outputRange,
                        Extrapolate.CLAMP
                    ),
                },
            ],
        };
    }, [animValue, index, length]);

    return (<View style={[{
        width, height: height,
        borderRadius: 2,
        overflow: 'hidden',
        marginHorizontal: 2,
    }, viewStyle]}><Animated.View style={[{
        borderRadius: 2, flex: 1,
    }, animStyle, highlightedViewStyle]} />
    </View>);
};

export default PaginationItem